import React, { useState } from 'react';
// react library for routing
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
import Axios from 'axios'
import api from '../../services/api';
// reactstrap components
import Avatar from '../Avatar';
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Row,
  Col,
  Modal,
  Media,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import EmpresaContext from '../../contexts/Empresa';
import AuthContext from '../../contexts/Auth';
import NotificacoesLista from '../NotificacoesLista';


import moment from 'moment'
import playneeIcon from "../../assets/icon.png"
import { authStorageKey, empresaStorageKey, userStorageKey } from "../../utils";

class Sidebar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalInicialOpen: true,
      modalAlertaJobsOpen: false,
      modalTermosUsoOpen: false,
      displayButtonContratar: 'none',
      routes: props.routes,
      termosUsoVigentes: null,
      termosUsoVigentesAceitos: false,
      ...this.getCollapseStates(props.routes),
      logoHover: false,
      textCompany: "",
      isGearOpen: false,
      gearPanelLeft: 0,
      gearPanelBottom: 0,
      isEmpresaOpen: false,
      empresaPanelLeft: 0,
      empresaPanelBottom: 0,
    };
    this.gearBtnRef = React.createRef();
    this.empresaBtnRef = React.createRef();
  }


  openEmpresaPanel = () => {
    const sidenav = document.querySelector('.sidenav');
    const sidenavRight = sidenav ? sidenav.getBoundingClientRect().right + 8 : 258;
    const btnRect = this.empresaBtnRef.current?.getBoundingClientRect();
    const bottom = btnRect ? window.innerHeight - btnRect.bottom : 40;
    const isMobile = window.innerWidth <= 768;
    const left = isMobile ? 8 : sidenavRight;
    this.setState({ isEmpresaOpen: true, empresaPanelLeft: left, empresaPanelBottom: bottom });
  };

  closeEmpresaPanel = () => {
    this.setState({ isEmpresaOpen: false, textCompany: '' });
  };

  openGearPanel = () => {
    const sidenav = document.querySelector('.sidenav');
    const sidenavRight = sidenav ? sidenav.getBoundingClientRect().right + 8 : 258;
    const btnRect = this.gearBtnRef.current?.getBoundingClientRect();
    const bottom = btnRect ? window.innerHeight - btnRect.bottom : 40;
    const isMobile = window.innerWidth <= 768;
    const left = isMobile ? 8 : sidenavRight;
    this.setState({ isGearOpen: true, gearPanelLeft: left, gearPanelBottom: bottom });
  };

  closeGearPanel = () => {
    this.setState({ isGearOpen: false });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.routes != this.props.routes && this.props.routes) {
      this.setState({
        ...this.state,
        ...this.getCollapseStates(this.props.routes)
      })
    }
  }

  getToken = () => {
    let auth = localStorage.getItem(authStorageKey)
    if (auth) {
      const authObj = JSON.parse(auth)
      return authObj.token
    }
  }
  
  getRoleUser = (role) => {
    let user = localStorage.getItem(userStorageKey)
    if (user) {
      const userObj = JSON.parse(user)
      let roles = userObj?.roles?.find(item => item.slug === role)
      return !!roles
    }

    return false
  }

  getPerfilNegocioEmpresaLogada = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      return empresaObj.perfil_negocio_id
    }
  }

  getIdEmpresaLogada = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      return empresaObj.id
    }
  }

  getLinkVideoInicial = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      return empresaObj.link_video_inicial;
    }
  }

  getPermissaoVideoInicial = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      return empresaObj.flag_mostrar_video_inicial;
    }
  }

  getHasEmpresaLogada = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      if (empresaObj && empresaObj.id > 0) {
        if (empresaObj.assinatura_id) {
          this.state.displayButtonContratar = 'none'
        } else {
          this.state.displayButtonContratar = 'flex'
        }
        return true;
      } else {
        this.state.displayButtonContratar = 'none'
        return false;
      }
    }
  }

  getTermosUsoIdEmpresaLogada = () => {
    let empresa = localStorage.getItem(empresaStorageKey)
    if (empresa) {
      const empresaObj = JSON.parse(empresa)
      return empresaObj.termos_uso_id
    }
  }

  async canShowModalByDuracaoJornada() {

    try {
      var url = `${process.env.REACT_APP_ACELERANDO_PESSOAS_BACK_URL}/sdp/api/acelerando/alunos/canshowjornada?token=${this.getToken()}&idPerfilNegocio=${this.getPerfilNegocioEmpresaLogada()}`
      const response = await Axios.get(url)
      //console.log('Validando Can Show Modal')
      //console.log({ response })
      if (response && response.data && (response.data.can_show == 'true' || response.data.can_show)) {
        //console.log('Dias Restantes')
        localStorage.setItem('diasFimJornada', response.data.dias_restantes)
        //console.log(response.data.dias_restantes)
      }
      return response.data.can_show
    } catch (error) {
      console.error(error)
      console.log('Não foi possível validar Modal By Duração da Jornada')
      return false
    }
  }

  async canShowModalByValidacaoJobs() {
    try {
      const response = await api.get(`/common/validacaojobs`);

      if (response && response.data && response.data.length > 0) {
        return response.data[0].alerta
      } else {
        return false
      }

    } catch (error) {
      console.log('ERROR VALIDAÇÂO JOBS')
      console.error(error)
      console.log('Não foi possível validar Modal By Validacao Jobs')
      return false
    }
  }

  async getTermosUsoVigente(onde) {
    //console.log({ onde })
    try {
      let termoVigente = this.state.termosUsoVigentes
      if (!termoVigente) {
        // console.log('BUSCAR TERMO')
        const response = await api.get(`common/empresas/${this.getIdEmpresaLogada()}/termos-uso-vigente`)
        if (response.data) {
          this.state.termosUsoVigentes = response.data
        }
        return response.data
      } else {
        // console.log('TERMO JÁ CARREGADO')
        return termoVigente
      }
    } catch (error) {
      console.log('ERROR GET TERMO VIGENTE')
      console.error(error)
      console.log('Não foi possível buscar termos de uso vigentes')
      return null
    }
  }


  async canShowModalByValidacaoTermosUso() {
    try {
      console.log('canShowModalByValidacaoTermosUso')
      // const response = await api.get(`common/empresas/${this.getIdEmpresaLogada()}/termos-uso-vigente`)
      // console.log(response.data)
      // if (response.data) {
      //   this.state.termosUsoVigentes = response.data
      // }

      // const termoVigente = await this.getTermosUsoVigente()
      let termoVigente = this.state.termosUsoVigentes
      if (!termoVigente) {
        termoVigente = await this.getTermosUsoVigente('canShow')
        if (termoVigente) {
          this.state.termosUsoVigentes = termoVigente
        }
      }

      let empresa = localStorage.getItem(empresaStorageKey)
      if (this.getRoleUser('administrador_empresa')) {
        if (empresa && termoVigente) {
          const empresaObj = JSON.parse(empresa)
          console.log({ empresaObj })
          if (termoVigente.id && empresaObj.termos_uso_id && (termoVigente.id != empresaObj.termos_uso_id)) {
            return true
          } else {
            if (termoVigente.id && !empresaObj.termos_uso_id) {
              return true
            }
          }
        }
      }
      return false

    } catch (error) {
      console.log('ERROR VALIDAÇÂO TERMOS USO')
      console.error(error)
      console.log('Não foi possível validar Modal By Validacao Termos Uso')
      return false
    }
  }


  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname == routeName ? "active" : "";
  };
  // Menu fechado: qualquer clique nele abre, como no ChatGPT. Fechado so ha
  // icones, entao navegar fica para quando estiver aberto.
  //
  // Precisa ser na fase de captura: no borbulhamento o onClick do NavLink ja
  // teria rodado e o react-router teria navegado antes de chegarmos aqui.
  handleClickSidenav = (e) => {
    if (this.props.sidenavOpen) return;
    e.preventDefault();
    e.stopPropagation();
    this.props.toggleSidenav();
  };

  // Icone de painel que abre e fecha o menu. Traco fino num viewBox de 24 e
  // cantos bem arredondados: fica leve, sem competir com os icones do menu.
  renderIconeMenu = (tamanho = 20) => (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color: '#32325d' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <line x1="9.5" y1="4" x2="9.5" y2="20" />
    </svg>
  );

  // Menu fechado: mostra a logo e, com o mouse em qualquer ponto do aside,
  // troca pelo icone de abrir. O estado do hover vem do proprio Navbar; trocar
  // so a logo mantem a largura do menu intacta.
  renderLogoOuIcone = (tamanho = 32) => (
    <div
      onClick={this.props.toggleSidenav}
      title="Abrir menu"
      style={{ cursor: 'inherit', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '32px', height: `${tamanho}px` }}
    >
      {this.state.logoHover ? (
        this.renderIconeMenu(Math.round(tamanho * 0.65))
      ) : (
        <img
          src="/iconbackground.jpeg"
          alt="Playnee"
          style={{ width: `${tamanho}px`, height: `${tamanho}px`, objectFit: 'cover', borderRadius: '50%', display: 'block', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
        />
      )}
    </div>
  );

  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname === (routes[i].layout || "") + routes[i].path) {
        return true;
      }
    }
    return false;
  }
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  closeSidenav = () => {
    if (window.innerWidth < 1200) {
      this.props.toggleSidenav();
    }
  };

  // toggles modal between opened and closed (true/false)
  toggleModalInicial = () => {
    this.setState({
      modalInicialOpen: !this.state.modalInicialOpen
    });
  };

  // toggles modal between opened and closed (true/false)
  toggleModalAlertaJobs = () => {
    this.setState({
      modalAlertaJobsOpen: !this.state.modalAlertaJobsOpen
    });
  };

  // toggles modal between opened and closed (true/false)
  toggleModalTermosUso = () => {
    this.setState({
      modalTermosUsoOpen: !this.state.modalTermosUsoOpen
    });
  };

  // closes the modal
  openModalInicial = () => {
    this.setState({
      modalInicialOpen: true
    });
  };

  // closes the modal
  openModalAlertaJobs = () => {
    this.setState({
      modalAlertaJobsOpen: true
    });
  };

  // closes the modal
  openModalTermosUso = () => {
    this.setState({
      modalTermosUsoOpen: true
    });
  };

  // aceitar Termos de Uso
  aceitarTermosUso = (aceitar) => {
    this.setState({
      termosUsoVigentesAceitos: aceitar
    });
  };

  // aceitar Termos de Uso
  getNomeTermosUso = () => {

    if (this.state.termosUsoVigentes) {
      return this.state.termosUsoVigentes.nome
    } else {
      return 'Termo Inválido'
    }

  };

  // closes the modal
  closeModalInicial = () => {
    //console.log('Entrou no CLOSE MODAL')
    var currentDate = moment();
    var new_date = currentDate.add(1, 'days');
    localStorage.setItem('proximaDataMostrarModalInicial', new_date)

    this.setState({
      modalInicialOpen: false
    });
  };

  // closes the modal
  closeModalAlertaJobs = () => {
    //console.log('Entrou no CLOSE MODAL')
    var currentDate = moment();
    var new_date = currentDate.add(1, 'hours');
    localStorage.setItem('proximaDataMostrarModalAlertaJobs', new_date)

    this.setState({
      modalAlertaJobsOpen: false
    });
  };

  // closes the modal
  closeModalTermosUso = () => {
    //console.log('Entrou no CLOSE MODAL')
    var currentDate = moment();
    var new_date = currentDate.add(1, 'hours');
    localStorage.setItem('proximaDataMostrarModalTermosUso', new_date)

    this.setState({
      modalTermosUsoOpen: false
    });
  };

  // closes the modal
  naoMostrarMaisModalInicial = () => {
    //console.log('Entrou no NÂO MOSTRAR MAIS CLOSE MODAL')
    localStorage.setItem('isModalInicialOpen', 'false')
    this.setState({
      modalInicialOpen: false
    });
  };

  async getStatusModalInicial() {
    var isModalInicialOpen = localStorage.getItem('isModalInicialOpen')
    var proximaDataMostrarModalInicial = localStorage.getItem('proximaDataMostrarModalInicial')

    var canShowModalByDuracaoJornada = localStorage.getItem('canShowModalByDuracaoJornada')
    var proximaDataValidarCanShowModalByDuracaoJornada = localStorage.getItem('proximaDataValidarCanShowModalByDuracaoJornada')

    if (proximaDataValidarCanShowModalByDuracaoJornada == null) {
      var currentDate = moment();
      var new_date = currentDate.add(1, 'days');
      localStorage.setItem('proximaDataValidarCanShowModalByDuracaoJornada', new_date)
    }

    if (isModalInicialOpen == null) {
      localStorage.setItem('isModalInicialOpen', 'true')
      this.state.modalInicialOpen = true
      isModalInicialOpen = true
    }

    if (isModalInicialOpen == 'true') {
      //console.log('MODAL STORAGE TRUE')
      if (this.getHasEmpresaLogada()) {

        if (this.getPermissaoVideoInicial() && this.getPermissaoVideoInicial() == 'true') {
          //console.log('FLAG PERMISSÂO MOSTRAR MODAL TRUE')
          if (proximaDataMostrarModalInicial ? moment().isAfter(proximaDataMostrarModalInicial) : true) {
            //console.log('PROXIMA DATA CHEGOU')
            //console.log('PERMISSÃO BY DURAÇÃO')
            //console.log({canShowModalByDuracaoJornada})
            //console.log({proximaDataValidarCanShowModalByDuracaoJornada})
            if (canShowModalByDuracaoJornada == null || (proximaDataValidarCanShowModalByDuracaoJornada ? moment().isAfter(proximaDataValidarCanShowModalByDuracaoJornada) : true)) {
              var permissao = await this.canShowModalByDuracaoJornada()
              localStorage.setItem('canShowModalByDuracaoJornada', permissao)
              canShowModalByDuracaoJornada = permissao
              var currentDate = moment();
              var new_date = currentDate.add(1, 'days');
              localStorage.setItem('proximaDataValidarCanShowModalByDuracaoJornada', new_date)
            }
            //console.log({ canShowModalByDuracaoJornada })
            if (canShowModalByDuracaoJornada == 'true') {
              //console.log('PERMISSAO BY DURAÇÃO CONCEDIDA (TRUE)')
              this.state.modalInicialOpen = true
            } else {
              //console.log('PERMISSAO BY DURAÇÃO NÃO CONCEDIDA (FALSE)')
              this.state.modalInicialOpen = false
            }

          } else {
            //console.log('MAS PROXIMA DATA NÂO CHEGOU AINDA')
            this.state.modalInicialOpen = false
          }
        } else {
          //console.log('SEM FLAG PERMISSÃO MOSTRAR MODAL ou FLAG FALSE')
          this.state.modalInicialOpen = false
        }

      } else {
        //console.log('EMPRESA NÂO LOGADA AINDA')
        this.state.modalInicialOpen = false
      }
    } else {
      // console.log('MODAL STORAGE FALSE')
      this.state.modalInicialOpen = false
    }

    // console.log('STATUS FINAL MODAL: ' + this.state.modalInicialOpen)
  }

  async getStatusModalAlertaJobs() {
    var isModalAlertaJobsOpen = localStorage.getItem('isModalAlertaJobsOpen')
    var proximaDataMostrarModalAlertaJobs = localStorage.getItem('proximaDataMostrarModalAlertaJobs')

    var canShowModalByValidacaoJobs = localStorage.getItem('canShowModalByValidacaoJobs')
    var proximaDataValidarCanShowModalByValidacaoJobs = localStorage.getItem('proximaDataValidarCanShowModalByValidacaoJobs')

    if (proximaDataValidarCanShowModalByValidacaoJobs == null) {
      var currentDate = moment();
      var new_date = currentDate.add(1, 'hours');
      localStorage.setItem('proximaDataValidarCanShowModalByValidacaoJobs', new_date)
    }

    if (isModalAlertaJobsOpen == null) {
      localStorage.setItem('isModalAlertaJobsOpen', 'true')
      this.state.modalAlertaJobsOpen = true
      isModalAlertaJobsOpen = true
    }

    if (isModalAlertaJobsOpen == 'true') {
      //console.log('MODAL STORAGE TRUE')
      if (this.getHasEmpresaLogada()) {

        if (proximaDataMostrarModalAlertaJobs ? moment().isAfter(proximaDataMostrarModalAlertaJobs) : true) {
          //console.log('PROXIMA DATA CHEGOU')
          //console.log('PERMISSÃO BY DURAÇÃO')
          //console.log({canShowModalByDuracaoJornada})
          //console.log({proximaDataValidarCanShowModalByDuracaoJornada})
          if (canShowModalByValidacaoJobs == null || (proximaDataValidarCanShowModalByValidacaoJobs ? moment().isAfter(proximaDataValidarCanShowModalByValidacaoJobs) : true)) {
            var permissao = await this.canShowModalByValidacaoJobs()
            localStorage.setItem('canShowModalByValidacaoJobs', permissao)
            canShowModalByValidacaoJobs = permissao
            var currentDate = moment();
            var new_date = currentDate.add(1, 'hours');
            localStorage.setItem('proximaDataValidarCanShowModalByValidacaoJobs', new_date)
          }
          //console.log({ canShowModalByDuracaoJornada })
          if (canShowModalByValidacaoJobs == 'true') {
            //console.log('PERMISSAO BY DURAÇÃO CONCEDIDA (TRUE)')
            this.state.modalAlertaJobsOpen = true
          } else {
            //console.log('PERMISSAO BY DURAÇÃO NÃO CONCEDIDA (FALSE)')
            this.state.modalAlertaJobsOpen = false
          }

        } else {
          //console.log('MAS PROXIMA DATA NÂO CHEGOU AINDA')
          this.state.modalAlertaJobsOpen = false
        }


      } else {
        //console.log('EMPRESA NÂO LOGADA AINDA')
        this.state.modalAlertaJobsOpen = false
      }
    } else {
      // console.log('MODAL STORAGE FALSE')
      this.state.modalAlertaJobsOpen = false
    }

    // console.log('STATUS FINAL MODAL: ' + this.state.modalInicialOpen)
  }


  async getStatusModalTermosUso() {
    var isModalTermosUsoOpen = localStorage.getItem('isModalTermosUsoOpen')
    var proximaDataMostrarModalTermosUso = localStorage.getItem('proximaDataMostrarModalTermosUso')

    var canShowModalByValidacaoTermosUso = localStorage.getItem('canShowModalByValidacaoTermosUso')
    var proximaDataValidarCanShowModalByValidacaoTermosUso = localStorage.getItem('proximaDataValidarCanShowModalByValidacaoTermosUso')

    if (proximaDataValidarCanShowModalByValidacaoTermosUso == null) {
      var currentDate = moment();
      var new_date = currentDate.add(1, 'hours');
      localStorage.setItem('proximaDataValidarCanShowModalByValidacaoTermosUso', new_date)
    }

    if (isModalTermosUsoOpen == null) {
      localStorage.setItem('isModalTermosUsoOpen', 'true')
      this.state.modalTermosUsoOpen = true
      isModalTermosUsoOpen = true
    }

    if (isModalTermosUsoOpen == 'true') {
      //console.log('MODAL STORAGE TRUE')
      if (this.getHasEmpresaLogada()) {

        if (proximaDataMostrarModalTermosUso ? moment().isAfter(proximaDataMostrarModalTermosUso) : true) {
          //console.log('PROXIMA DATA CHEGOU')
          //console.log('PERMISSÃO BY DURAÇÃO')
          //console.log({canShowModalByDuracaoJornada})
          //console.log({proximaDataValidarCanShowModalByDuracaoJornada})
          if (canShowModalByValidacaoTermosUso == null || (proximaDataValidarCanShowModalByValidacaoTermosUso ? moment().isAfter(proximaDataValidarCanShowModalByValidacaoTermosUso) : true)) {
            var permissao = await this.canShowModalByValidacaoTermosUso()
            localStorage.setItem('canShowModalByValidacaoTermosUso', permissao)
            canShowModalByValidacaoTermosUso = permissao
            var currentDate = moment();
            var new_date = currentDate.add(1, 'hours');
            localStorage.setItem('proximaDataValidarCanShowModalByValidacaoTermosUso', new_date)
          }
          //console.log({ canShowModalByDuracaoJornada })
          if (canShowModalByValidacaoTermosUso == 'true') {
            //console.log('PERMISSAO BY DURAÇÃO CONCEDIDA (TRUE)')
            this.state.modalTermosUsoOpen = true
          } else {
            //console.log('PERMISSAO BY DURAÇÃO NÃO CONCEDIDA (FALSE)')
            this.state.modalTermosUsoOpen = false
          }

        } else {
          //console.log('MAS PROXIMA DATA NÂO CHEGOU AINDA')
          this.state.modalTermosUsoOpen = false
        }


      } else {
        //console.log('EMPRESA NÂO LOGADA AINDA')
        this.state.modalTermosUsoOpen = false
      }
    } else {
      // console.log('MODAL STORAGE FALSE')
      this.state.modalTermosUsoOpen = false
    }

    // console.log('STATUS FINAL MODAL: ' + this.state.modalInicialOpen)
  }

  handlerVerTermos() {
    try {
      console.log(this.state.termosUsoVigentes?.link_url)
      window.open(this.state.termosUsoVigentes?.link_url, '_blank');
    } catch (error) {
      console.log(error)
    }
  }


  async handlerAceitarTermos() {
    try {
      const response = await api.post(`/common/empresas/${this.getIdEmpresaLogada()}/termos-uso/${this.state.termosUsoVigentes?.id}/assinar-termos-uso`)
      console.log('Retorno Aceitar Termos')
      console.log({ response })
      if (response.data && response.data.termos_uso_id && response.data.termos_uso_id > 0) {
        this.closeModalTermosUso()
      }

    } catch (error) {
      console.log(error)

    }
  }


  onAcademyClicked(eventAcademy, propetiesAcademy) {
    //var href = `${propetiesAcademy.path}${propetiesAcademy.alias === 'treinamento_playnee' ? '?tokenPlaynee=' + this.getToken() + '&idPerfilNegocio=' + this.getPerfilNegocioEmpresaLogada() : ''}`
    // window.open(this.state.linkPlayneeAcademy)
    window.open(this.state.linkPlayneeAcademy)
  }

  onContratarClicked(eventAcademy, propetiesAcademy) {
    var url = ``
    url = `https://playnee.com/planos-precos.html?empresa_id=${this.getIdEmpresaLogada()}`
    //teste local
    //url = `http://127.0.0.1:5500/planos-precos.html?empresa_id=${this.getIdEmpresaLogada()}`
    window.open(url)
  }

  onAvisarSuporteClicked() {
    var url = ``
    url = `https://api.whatsapp.com/send?phone=5579996741562&text=Olá%20Suporte.%20Favor%20verificar%20os%20JOBs,%20pois%20algum%20deles%20pode%20estar%20atrasado%20em%20sua%20execução.%20Obrigado!`
    window.open(url)
  }


  // skeleton placeholder shown while routes are loading
  renderSkeleton = () => {
    // Abre e fecha somente pelo botao do cabecalho, nunca pelo hover.
    const isExpanded = this.props.sidenavOpen;
    const items = Array.from({ length: 8 });
    const shimmerStyle = {
      background:
        "linear-gradient(90deg, #e9ecef 0%, #f5f7fa 50%, #e9ecef 100%)",
      backgroundSize: "200% 100%",
      animation: "sidebarSkeletonShimmer 1.4s ease-in-out infinite",
      borderRadius: "4px",
    };
    return items.map((_, key) => (
      <li
        key={`skel-${key}`}
        className={classnames("nav-item", {
          "mx-2 mb-1": isExpanded,
          "d-flex justify-content-center w-100 mx-0": !isExpanded,
        })}
        style={{ listStyle: "none" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: isExpanded ? "flex-start" : "center",
            width: isExpanded ? "calc(100% - 1.5rem)" : "40px",
            height: "40px",
            borderRadius: "8px",
            padding: isExpanded ? "0 0.75rem" : "0",
            margin: isExpanded ? "0 auto" : "1px 0",
          }}
        >
          <div style={{ ...shimmerStyle, width: "20px", height: "20px" }} />
          {isExpanded && (
            <div
              style={{
                ...shimmerStyle,
                flex: 1,
                height: "10px",
                marginLeft: "12px",
              }}
            />
          )}
        </div>
      </li>
    ));
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    // Abre e fecha somente pelo botao do cabecalho, nunca pelo hover.
    const isExpanded = this.props.sidenavOpen;
    const isLoading =
      !routes ||
      routes.length === 0 ||
      (routes.length === 1 && Object.keys(routes[0] || {}).length === 0);
    if (isLoading) {
      return this.renderSkeleton();
    }
    return routes.map((prop, key) => {
      if (prop.redirect || prop.hidden) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              className={classnames("d-flex align-items-center justify-content-between mx-2 mb-1", {
                "bg-lighter rounded-8": this.getCollapseInitialState(prop.views)
              })}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
              style={{
                borderRadius: "8px",
                padding: "0.65rem 1rem",
                transition: "all 0.2s ease"
              }}
            >
              <div className="d-flex align-items-center">
                {prop.icon ? <i className={classnames(prop.icon, {
                  "text-primary": this.getCollapseInitialState(prop.views),
                  "text-darker": !this.getCollapseInitialState(prop.views)
                })} style={{ width: "20px" }} /> : null}
                <span className={classnames("nav-link-text ml-2 font-weight-500", {
                  "text-primary font-weight-600": this.getCollapseInitialState(prop.views),
                  "text-darker": !this.getCollapseInitialState(prop.views)
                })}>{prop.name}</span>
              </div>
            </NavLink>
            <Collapse isOpen={this.state[prop.state]}>
              <Nav className="nav-sm flex-column ml-3">
                {this.createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }


      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);
      const isExternalLink = prop.path ? prop.path.match(regex) ? true : (prop.path.includes('http://localhost:5500') || prop.path.includes('http://localhost:5501') || prop.path.includes('http://localhost:8080') || prop.path.includes('http://localhost:8081')) : false
      let isExternalLinkLocal = false;

      if (!isExternalLink) {
        isExternalLinkLocal = prop.path ? prop.path.includes('file:///') : false
      }

      if (isExternalLink && prop?.alias == 'treinamento_playnee') {
        this.state.linkPlayneeAcademy = `${prop.path}?tokenPlaynee=${this.getToken()}&idPerfilNegocio=${this.getPerfilNegocioEmpresaLogada()}&idEmpresaLogada=${this.getIdEmpresaLogada()}`
      }
      let auth = localStorage.getItem(authStorageKey)
      const authObj = JSON.parse(auth)


      return (
        <NavItem
          className={classnames(this.activeRoute(prop.layout + prop.path), {
            "mx-2 mb-1": isExpanded,
            "d-flex justify-content-center w-100 mx-0": !isExpanded
          })}
          key={key}
        >
          {isExternalLink || isExternalLinkLocal ? (
            prop.alias == "treinamento_playnee" ? (
              <div
                className={classnames("w-100", { "mb-0 mt-0": isExpanded, "d-flex flex-column align-items-center": !isExpanded })}
                style={{ transition: "all 0.2s ease" }}
              >
                <a
                  className={classnames("d-flex align-items-center", { 
                    "justify-content-start": isExpanded,
                    "justify-content-center": !isExpanded 
                  })}
                  href={`https://academy.playnee.com/auth/signin?token=${authObj.token}`}
                  target="_blank"
                  style={{
                    background: isExpanded ? "#fff" : "transparent",
                    border: isExpanded ? "1px solid #e9ecef" : "none",
                    color: "#f5365c",
                    padding: isExpanded ? "0.6rem 0.75rem" : "0.6rem 0",
                    borderRadius: "8px",
                    boxShadow: isExpanded ? "0 1px 3px rgba(0,0,0,0.05)" : "none",
                    transition: "all 0.2s ease",
                    width: isExpanded ? "calc(100% - 1.5rem)" : "100%",
                    maxWidth: isExpanded ? "none" : "40px",
                    height: isExpanded ? "auto" : "40px",
                    textDecoration: "none",
                    margin: isExpanded ? "0 auto" : "0"
                  }}
                >
                  {prop.icon !== undefined ? (
                    <>
                      <i className={classnames(prop.icon, { "mr-2": isExpanded })} style={{ fontSize: "1.2rem", width: isExpanded ? "24px" : "20px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }} />
                      {isExpanded && <span className="font-weight-600" style={{ fontSize: "0.9rem", lineHeight: "1.2" }}>{prop.name}</span>}
                    </>
                  ) : (
                    isExpanded && <span className="font-weight-600" style={{ fontSize: "0.9rem", lineHeight: "1.2" }}>{prop.name}</span>
                  )}
                </a>
                <hr style={{ borderColor: "#e9ecef", width: isExpanded ? "calc(100% - 2rem)" : "80%", margin: isExpanded ? "0.75rem 1rem" : "0.5rem auto" }} />
              </div>
            )  : (
              <NavLink 
                href={prop.path} 
                target="_blank"
                style={{
                  borderRadius: "8px",
                  margin: isExpanded ? "0 4px" : "1px 0",
                  padding: isExpanded ? "0.65rem 1rem" : "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isExpanded ? "flex-start" : "center",
                  width: isExpanded ? "100%" : "40px",
                  height: isExpanded ? "auto" : "40px"
                }}
              >
                {prop.icon !== undefined ? (
                  <>
                    <i className={classnames(prop.icon, { "mr-3": isExpanded || !isExpanded, "text-darker": true })} style={{ width: isExpanded ? "auto" : "20px", textAlign: "center" }} />
                    {isExpanded && <span className="nav-link-text text-darker font-weight-500">{prop.name}</span>}
                  </>
                ) : (
                   isExpanded && <span className="nav-link-text text-darker font-weight-500">{prop.name}</span>
                )}
              </NavLink>
            )
          ) : prop.alias == "conversas" ? (
            <div 
              className={classnames("w-100", { "mt-1 mb-1": isExpanded, "d-flex justify-content-center": !isExpanded })}
              style={{ transition: "all 0.2s ease" }}
            >
              <NavLink
                activeClassName=""
                to={prop.layout + prop.path}
                onClick={this.closeSidenav}
                tag={NavLinkRRD}
                className={classnames("d-flex align-items-center", { 
                  "justify-content-start": isExpanded,
                  "justify-content-center": !isExpanded 
                })}
                style={{
                  background: isExpanded ? "#fff" : "transparent",
                  border: isExpanded ? "1px solid #e9ecef" : "none",
                  color: "#0747d6",
                  padding: isExpanded ? "0.6rem 0.75rem" : "0.6rem 0",
                  borderRadius: "8px",
                  boxShadow: isExpanded ? "0 1px 3px rgba(0,0,0,0.05)" : "none",
                  transition: "all 0.2s ease",
                  width: isExpanded ? "calc(100% - 1.5rem)" : "100%",
                  maxWidth: isExpanded ? "none" : "40px",
                  height: isExpanded ? "auto" : "40px",
                  textDecoration: "none",
                  margin: isExpanded ? "0 auto" : "0"
                }}
              >
                {prop.icon !== undefined ? (
                  <>
                    <i className={classnames(prop.icon, { "mr-2": isExpanded })} style={{ fontSize: "1.2rem", width: isExpanded ? "24px" : "20px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }} />
                    {isExpanded && <span className="font-weight-600" style={{ fontSize: "0.9rem", lineHeight: "1.2" }}>{prop.name}</span>}
                  </>
                ) : (
                  isExpanded && <span className="font-weight-600" style={{ fontSize: "0.9rem", lineHeight: "1.2" }}>{prop.name}</span>
                )}
              </NavLink>
            </div>
          ) : (
            <NavLink
              to={prop.layout + prop.path}
              activeClassName="active"
              onClick={this.closeSidenav}
              tag={NavLinkRRD}
              style={{
                borderRadius: "8px",
                margin: isExpanded ? "1px 4px" : "1px 0",
                padding: isExpanded ? "0.65rem 0" : "0",
                transition: "background-color 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: isExpanded ? "flex-start" : "center",
                width: isExpanded ? "auto" : "40px",
                height: isExpanded ? "auto" : "40px"
              }}
              className={classnames({
                "bg-lighter": this.activeRoute(prop.layout + prop.path) === "active"
              })}
            >
              {prop.icon !== undefined ? (
                <>
                  <i
                    className={classnames(prop.icon, {
                      "text-primary": this.activeRoute(prop.layout + prop.path) === "active",
                      "text-darker": this.activeRoute(prop.layout + prop.path) !== "active"
                    })}
                    style={{ width: isExpanded ? "auto" : "20px", textAlign: "center" }}
                  />
                  <span className={classnames("nav-link-text font-weight-500", {
                    "text-primary font-weight-600": this.activeRoute(prop.layout + prop.path) === "active",
                    "text-darker": this.activeRoute(prop.layout + prop.path) !== "active"
                  })}>{prop.name}</span>
                </>
              ) : (
                <span className={classnames("nav-link-text font-weight-500", {
                  "text-primary font-weight-600": this.activeRoute(prop.layout + prop.path) === "active",
                  "text-darker": this.activeRoute(prop.layout + prop.path) !== "active"
                })}>{prop.name}</span>
              )}
            </NavLink>
          )}
        </NavItem>
      );
    });
  };

  createDocLinks = () => {
    if (process.env.NODE_ENV != 'production') {
      return (
        <>
          <hr className="my-3" />
          <h6 className="navbar-heading p-0 text-muted">Documentation</h6>
          <Nav className="mb-md-3" navbar>
            <NavItem>
              <NavLink
                href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/overview?ref=adpr-sidebar"
                target="_blank"
              >
                <i className="ni ni-spaceship" />
                <span className="nav-link-text">Getting started</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/colors?ref=adpr-sidebar"
                target="_blank"
              >
                <i className="ni ni-palette" />
                <span className="nav-link-text">Foundation</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/alert?ref=adpr-sidebar"
                target="_blank"
              >
                <i className="ni ni-ui-04" />
                <span className="nav-link-text">Components</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/charts?ref=adpr-sidebar"
                target="_blank"
              >
                <i className="ni ni-chart-pie-35" />
                <span className="nav-link-text">Plugins</span>
              </NavLink>
            </NavItem>
          </Nav>
        </>
      )
    }
  }

  render() {

    const { routes, logo } = this.props;
    //console.log(routes)
    this.getTermosUsoVigente('render');
    this.getStatusModalInicial();
    this.getStatusModalAlertaJobs();
    this.getStatusModalTermosUso();
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    // Abre e fecha somente pelo botao do cabecalho, nunca pelo hover.
    const isExpanded = this.props.sidenavOpen;
    const scrollBarInner = (
      <div className="scrollbar-inner d-flex flex-column" style={{ height: '100%' }}>
        <div className={classnames("sidenav-header d-flex align-items-center justify-content-center", { "px-3": isExpanded })} style={{ height: isExpanded ? '100px' : '100px', padding: !isExpanded ? '0' : undefined, margin: !isExpanded ? '0 -1rem' : undefined }}>
          {isExpanded ? (
                    <div className="d-flex align-items-center justify-content-center w-100">
                      <NavbarBrand {...navbarBrandProps} className="py-2 px-3 mt-4">
                        <img
                          alt={logo.imgAlt}
                          src={logo.imgSrc}
                          className="navbar-brand-img"
                          style={{ maxHeight: '40px', width: 'auto' }}
                        />
                      </NavbarBrand>
                    </div>
          ) : (
            this.renderLogoOuIcone(32)
          )}
        </div>
        <div className="navbar-inner">
          <Collapse navbar isOpen={true}>
            <Nav navbar>{this.createLinks(routes)}</Nav>
            {this.createDocLinks()}
          </Collapse>
        </div>
        <div className="mt-auto p-3 border-top">
          <EmpresaContext.Consumer>
            {({ empresaSelecionada, empresas, changeEmpresaSelecionada }) => (
              <UncontrolledDropdown className="mb-3">
                <DropdownToggle
                  caret={isExpanded}
                  color="secondary"
                  className={classnames("w-100 text-left", { "p-0": !isExpanded })}
                  style={{
                    background: "transparent",
                    border: isExpanded ? "1px solid #e9ecef" : "none",
                    color: "#525f7f",
                    boxShadow: "none",
                    padding: isExpanded ? "0.5rem 0.75rem" : "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isExpanded ? "space-between" : "center",
                    minHeight: "40px"
                  }}
                >
                  <div className={classnames("text-truncate", { "mr-2": isExpanded })}>
                    <i className="fas fa-city" style={{ fontSize: isExpanded ? "inherit" : "1.2rem" }}></i>
                    {isExpanded && <span className="ml-2">{empresaSelecionada?.nome || "Selecionar Empresa"}</span>}
                  </div>
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    background: "#118EEF",
                    width: isExpanded ? "100%" : "200px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  {isExpanded && (
                    <div className="px-3 pb-3">
                      <Input
                        bsSize="sm"
                        placeholder="Buscar empresa..."
                        type="search"
                        value={this.state.textCompany}
                        onChange={(e) => this.setState({ textCompany: e.target.value })}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  )}
                  {empresas
                    .filter(e => e.nome.toLowerCase().includes(this.state.textCompany.toLowerCase()))
                    .map((empresa, key) => (
                      <DropdownItem
                        key={key}
                        onClick={() => {
                          changeEmpresaSelecionada(empresa);
                          sessionStorage.clear();
                          document.location.reload();
                        }}
                        style={{
                          color: "white",
                          textAlign: "left"
                        }}
                      >
                        {empresa.nome}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </EmpresaContext.Consumer>

          <Media className={classnames("align-items-center", { "justify-content-center": !isExpanded })}>
            <div style={{ flexShrink: 0 }}>
              <Avatar
                user={JSON.parse(localStorage.getItem(userStorageKey))}
                className="bg-secondary"
                style={{ color: "blue", width: '38px', height: '38px', objectFit: 'cover' }}
              />
            </div>
            {isExpanded && (
              <>
                <Media body className="ml-2 overflow-hidden">
                  <span className="mb-0 text-sm font-weight-bold d-block text-truncate" style={{ color: "#525f7f" }}>
                    {JSON.parse(localStorage.getItem(userStorageKey))?.nome}
                  </span>
                  <span className="mb-0 text-xs text-muted d-block text-truncate">
                    {JSON.parse(localStorage.getItem(userStorageKey))?.email}
                  </span>
                </Media>
                <i className="fas fa-chevron-up ml-auto text-muted text-xs"></i>
              </>
            )}
          </Media>

        </div>


      </div>
    );

    return (
      <>
        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.modalInicialOpen}
          toggle={() => this.toggleModalInicial()}
          size="lg" style={{ maxWidth: '1024px', width: '100%' }}
        >
          <div className="modal-header" style={{ background: '#12ccf0', color: 'white', justifyContent: 'center' }}>
            <h8 className="modal-title" id="modal-title-notification" style={{ fontSize: 35, textAlign: 'center' }}>
              Bem vindo à sua jornada de crescimento
            </h8>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center" style={{ padding: 60, marginTop: -30, fontSize: 22, color: 'black' }}>
              Assista ao vídeo e entenda como você vai fazer o seu negócio crescer como nunca imaginou!
            </div>

            <Row>
              <Col lg={6} md={12} sm={12}>
                <div className="embed-responsive embed-responsive-4by3" >
                  <iframe className="embed-responsive-item" src={this.getLinkVideoInicial()} frameborder="0"></iframe>
                </div>
              </Col>

              <Col lg={6} md={12} sm={12} className={"star-row"} style={{ display: 'grid' }}>

                <div className={"star-div"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <i className="fas fa-star star-icon" style={{ fontSize: 40, color: 'green' }} />
                  <div style={{ marginLeft: 10, fontSize: 20, fontWeight: 500, color: 'black' }}>
                    Uma Jornada transformadora em apenas 30 dias.
                  </div>
                </div>

                <div className={"star-div"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                  <i className="fas fa-star star-icon" style={{ fontSize: 40, color: 'green' }} />
                  <div style={{ marginLeft: 10, fontSize: 20, fontWeight: 500, color: 'black' }}>
                    Estratégias práticas para aplicar em seu negócio.
                  </div>
                </div>

                <div className={"star-div"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                  <i className="fas fa-star star-icon" style={{ fontSize: 40, color: 'green' }} />
                  <div style={{ marginLeft: 10, fontSize: 20, fontWeight: 500, color: 'black' }}>
                    Conteúdo fácil de aplicar e direto ao ponto.
                  </div>
                </div>

                <div className={"star-div"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                  <i className="fas fa-star star-icon" style={{ fontSize: 40, color: 'green' }} />
                  <div style={{ marginLeft: 10, fontSize: 20, fontWeight: 500, color: 'black' }}>
                    Uma ferramenta para apoiar a execução das estratégias.
                  </div>
                </div>

                <div className={"star-div"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                  <Button
                    onClick={e => this.onAcademyClicked()}
                    className="btn-danger "
                    block
                    color="danger"
                    type="button">
                    Ir para minha jornada
                  </Button>
                </div>

              </Col>

            </Row>

            {localStorage.getItem('diasFimJornada') > -1 ?
              localStorage.getItem('diasFimJornada') > 1 ?
                <div className="py-3 text-center" style={{ padding: 60, fontSize: 22, color: 'black' }}>
                  Fique atento! Sua jornada termina em {localStorage.getItem('diasFimJornada')} dias!
                </div>
                :
                localStorage.getItem('diasFimJornada') > 0 ?
                  <div className="py-3 text-center" style={{ padding: 60, fontSize: 22, color: 'black' }}>
                    Fique atento! Sua jornada termina AMANHÃ!
                  </div>
                  :
                  <div className="py-3 text-center" style={{ padding: 60, fontSize: 22, color: 'black' }}>
                    Fique atento! Sua jornada termina HOJE!
                  </div>
              :
              <></>
            }

            <div style={{ display: this.state.displayButtonContratar, flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
              <Button
                onClick={e => this.onContratarClicked()}
                className="btn-success"
                block
                color="success"
                type="button">
                QUERO CONTRATAR AGORA
              </Button>
            </div>


          </div>
          <div className="modal-footer">

            <div style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between',
              padding: 4
            }}>

              <Button
                style={{ fontSize: 10, color: 'gray', height: 10, marginTop: 15 }}
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() => this.naoMostrarMaisModalInicial()}
              >
                não mostrar
              </Button>
              <Button
                onClick={() => this.closeModalInicial()}
                className="btn-white"
                color="default"
                type="button">
                Fechar
              </Button>

            </div>

          </div>
        </Modal>


        <Modal
          className="modal-dialog-centered modal-warning"
          size="md"
          isOpen={this.state.modalAlertaJobsOpen}
          toggle={() => this.toggleModalAlertaJobs()}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-notification">
              Alerta de JOBs Atrasados
            </h6>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className="fas fa-exclamation-circle ni-3x" />
              <h4 className="heading mt-4"></h4>
              <p>
                Se você está vendo esse aviso, é bem provavel que algum serviço automatizado do Playnee esteja atrasado em sua execução. Faça-nos um favor: avise ao setor de suporte técnico.
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="text-white ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={() => this.closeModalAlertaJobs()}
            >
              Fechar
            </Button>
            <Button
              onClick={() => this.onAvisarSuporteClicked()}
              className="btn-white"
              color="default"
              type="button">
              Avisar ao Suporte
            </Button>
          </div>
        </Modal>


        <Modal
          className={"modal-dialog-centered modal-danger"}
          size="md"
          isOpen={this.state.modalTermosUsoOpen}
        // toggle={() => this.toggleModalTermosUso()}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-notification">
              Assinatura de Política de Privacidade
            </h6>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className={"fas fa-file-signature ni-3x"}></i>
              <h4 className="heading mt-4"></h4>
              <>
                <p>
                  ATENÇÃO
                </p>
                <p>
                  A empresa ainda não aceitou os Termos de Uso vigentes. Acesse os Termos de Uso, leia atentamente e, após isso, registre a aceitação.
                </p>
                <p>
                  {/* {this.state.termosUsoVigentes?.nome} */}
                  {this.getNomeTermosUso()}
                </p>
              </>
              <div className="custom-control custom-checkbox mr-4">
                <input
                  className="custom-control-input"
                  id="check-sms"
                  type="checkbox"
                  checked={this.state.termosUsoVigentesAceitos}
                  onChange={({ target }) => this.aceitarTermosUso(target.checked)}
                />
                <label className="custom-control-label" htmlFor="check-sms">
                  Aceito os Termos Vigentes
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <div>
              <Button
                className="text-white ml-auto"
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() => this.closeModalTermosUso()}
              >
                Fechar
              </Button>

              <Button
                onClick={() => this.handlerVerTermos()}
                className="btn-white"
                color="default"
                type="button">
                Ver Termos
              </Button>

              <Button
                onClick={() => this.handlerAceitarTermos()}
                className="btn-white"
                color="default"
                type="button"
                disabled={!this.state.termosUsoVigentesAceitos}>
                Aceitar
              </Button>

            </div>
          </div>
        </Modal>


        <Navbar
          className="sidenav navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
          style={{
            position: 'fixed', top: '0', left: '0', height: '100vh', borderRadius: '0',
            borderRight: '1px solid #e9ecef', padding: '0', display: 'flex', flexDirection: 'column',
          }}
          onClickCapture={this.handleClickSidenav}
          onMouseEnter={() => !this.props.sidenavOpen && this.setState({ logoHover: true })}
          onMouseLeave={() => this.setState({ logoHover: false })}
        >
          {/* Botao de fechar, fora do fluxo do cabecalho para nao disputar
              espaco com a logo. So no desktop e so com o menu aberto: fechado,
              quem faz esse papel e a propria logo, que vira icone no hover. */}
          {this.props.sidenavOpen && (
            <div
              className="sidenav-toggler-botao"
              onClick={this.props.toggleSidenav}
              title="Fechar menu"
            >
              {this.renderIconeMenu(16)}
            </div>
          )}
          <div style={{ flex: 1, overflow: 'hidden', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {navigator.platform.indexOf("Win") > -1 ? (
              <PerfectScrollbar className="flex-grow-1">
                <div className="scrollbar-inner d-flex flex-column" style={{ height: '100%' }}>
                  <div className={classnames("sidenav-header d-flex align-items-center justify-content-center", { "px-3": isExpanded })} style={{ height: isExpanded ? '100px' : '100px', padding: !isExpanded ? '0' : undefined, margin: !isExpanded ? '0 -1rem' : undefined }}>
                    {isExpanded ? (
                      <div className="d-flex align-items-center justify-content-center w-100">
                        <NavbarBrand {...navbarBrandProps} className="py-2 px-3 mt-4">
                          <img
                            alt={logo.imgAlt}
                            src={logo.imgSrc}
                            className="navbar-brand-img"
                            style={{ maxHeight: '40px', width: 'auto' }}
                          />
                        </NavbarBrand>
                      </div>
                    ) : (
                      this.renderLogoOuIcone(32)
                    )}
                  </div>
                  <div className="navbar-inner">
                    <Collapse navbar isOpen={true}>
                      <Nav navbar>{this.createLinks(routes)}</Nav>
                      {this.createDocLinks()}
                    </Collapse>
                  </div>
                </div>
              </PerfectScrollbar>
            ) : (
              <div className="scrollbar-inner d-flex flex-column flex-grow-1" style={{ height: '100%', overflowY: 'auto' }}>
                <div className={classnames("sidenav-header d-flex align-items-center justify-content-center", { "px-3": isExpanded })} style={{ height: isExpanded ? '100px' : '78px', padding: !isExpanded ? '0' : undefined, margin: !isExpanded ? '0 -1rem' : undefined }}>
                    {isExpanded ? (
                      <div className="d-flex align-items-center justify-content-center w-100">
                        <NavbarBrand {...navbarBrandProps} className="p-0 m-0">
                          <img
                            alt={logo.imgAlt}
                            src={logo.imgSrc}
                            className="navbar-brand-img"
                            style={{ maxHeight: '40px', width: 'auto' }}
                          />
                        </NavbarBrand>
                      </div>
                    ) : (
                      this.renderLogoOuIcone(44)
                    )}
                  </div>
                  <div className="navbar-inner">
                    <Collapse navbar isOpen={true}>
                      <Nav navbar>{this.createLinks(routes)}</Nav>
                      {this.createDocLinks()}
                    </Collapse>
                  </div>
              </div>
            )}
          </div>

          <div className={classnames("sidebar-footer border-top bg-white w-100", { "p-3": isExpanded, "py-1 px-1": !isExpanded })}>
            <EmpresaContext.Consumer>
              {({ empresaSelecionada, empresas, changeEmpresaSelecionada }) => (
                <div className="d-flex align-items-center justify-content-center mb-3">
                  {this.state.isEmpresaOpen && (
                    <div
                      style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
                      onClick={this.closeEmpresaPanel}
                    />
                  )}
                  <button
                    ref={this.empresaBtnRef}
                    onClick={this.state.isEmpresaOpen ? this.closeEmpresaPanel : this.openEmpresaPanel}
                    className={classnames({
                      "w-100 text-left": isExpanded,
                      "p-0 d-flex justify-content-center align-items-center": !isExpanded,
                    })}
                    style={{
                      background: "white",
                      border: "1px solid #e9ecef",
                      color: "#525f7f",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      padding: isExpanded ? "0.6rem 0.75rem" : "0",
                      margin: isExpanded ? "0" : "8px 0",
                      width: isExpanded ? "100%" : "44px",
                      minWidth: isExpanded ? "100%" : "44px",
                      height: "44px",
                      minHeight: "44px",
                      borderRadius: "22px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: isExpanded ? "flex-start" : "center",
                      cursor: "pointer",
                    }}
                  >
                    <div className={classnames("d-flex align-items-center", { "w-100": isExpanded })}>
                      <i className="fas fa-city text-muted" style={{ fontSize: "1.1rem", margin: 0 }}></i>
                      {isExpanded && (
                        <span className="ml-2 text-sm font-weight-500 text-darker text-truncate" style={{ maxWidth: "150px" }}>
                          {empresaSelecionada?.nome || "Selecionar Empresa"}
                        </span>
                      )}
                    </div>
                  </button>
                  {this.state.isEmpresaOpen && (
                    <div
                      style={{
                        position: 'fixed',
                        left: this.state.empresaPanelLeft,
                        bottom: this.state.empresaPanelBottom,
                        zIndex: 1050,
                        background: '#ffffff',
                        borderRadius: '8px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                        width: '300px',
                        maxHeight: '400px',
                        overflowY: 'auto',
                        border: '1px solid rgba(0,0,0,.05)',
                      }}
                    >
                      <div className="px-3 pb-2 pt-2">
                        <Input
                          bsSize="sm"
                          placeholder="Buscar empresa..."
                          type="search"
                          className="form-control-alternative"
                          value={this.state.textCompany}
                          onChange={(e) => this.setState({ textCompany: e.target.value })}
                        />
                      </div>
                      {empresas
                        .filter(e => e.nome.toLowerCase().includes(this.state.textCompany.toLowerCase()))
                        .map((empresa, key) => (
                          <div
                            key={key}
                            onClick={() => {
                              changeEmpresaSelecionada(empresa);
                              sessionStorage.clear();
                              document.location.reload();
                            }}
                            style={{
                              padding: '8px 16px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #f6f9fc',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              color: '#525f7f',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f6f9fc' }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                          >
                            <i className="fas fa-city text-muted" style={{ fontSize: '0.8rem', flexShrink: 0 }} />
                            <span className="text-sm font-weight-500">{empresa.nome}</span>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </EmpresaContext.Consumer>

            <AuthContext.Consumer>
              {({ user, signout }) => (
                <div 
                  className={classnames("d-flex align-items-center w-100", { 
                    "justify-content-center flex-column": !isExpanded, 
                    "justify-content-between p-2": isExpanded 
                  })}
                  style={{
                    background: isExpanded ? "#ffffff" : "transparent",
                    border: isExpanded ? "1px solid #e9ecef" : "none",
                    borderRadius: "30px",
                    boxShadow: isExpanded ? "0 1px 3px rgba(0,0,0,0.05)" : "none",
                    minHeight: isExpanded ? "58px" : "auto"
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div style={{ flexShrink: 0 }} className={classnames({ "mb-2": !isExpanded })}>
                      <Avatar
                        user={user}
                        className="bg-secondary shadow-sm"
                        style={{ width: '36px', height: '36px', border: '2px solid #fff' }}
                      />
                    </div>
                    {isExpanded && (
                      <Media body className="ml-2 overflow-hidden">
                        <span className="mb-0 text-sm font-weight-600 d-block text-truncate text-dark" style={{ maxWidth: "100px" }} title={user?.name}>
                          {user?.name}
                        </span>
                      </Media>
                    )}
                  </div>
                  
                  <div
                    className="align-items-center"
                    style={{ display: isExpanded ? 'flex' : 'none' }}
                  >
                      {/* Backdrop */}
                      {this.state.isGearOpen && (
                        <div
                          style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
                          onClick={this.closeGearPanel}
                        />
                      )}
                      {/* Botão engrenagem */}
                      <button
                        ref={this.gearBtnRef}
                        onClick={this.state.isGearOpen ? this.closeGearPanel : this.openGearPanel}
                        className="p-1 m-0 mr-1"
                        style={{ background: 'transparent', border: 'none', boxShadow: 'none', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                      >
                        <i className="fas fa-cog text-muted" style={{ fontSize: '1.1rem' }}></i>
                      </button>
                      {/* Painel fixo ao lado do sidebar */}
                      {this.state.isGearOpen && (
                        <div
                          style={{
                            position: 'fixed',
                            left: this.state.gearPanelLeft,
                            bottom: this.state.gearPanelBottom,
                            zIndex: 1050,
                            background: '#ffffff',
                            borderRadius: '8px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                            minWidth: '220px',
                            border: '1px solid rgba(0,0,0,.05)',
                            overflow: 'hidden',
                          }}
                        >
                          <div style={{ padding: '6px 0' }}>
                            <div style={{ padding: '4px 16px 2px', fontSize: '11px', fontWeight: 600, color: '#8898aa', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                              Perfis
                            </div>
                            {user?.roles?.map((role, idx) => (
                              <div key={idx} style={{ padding: '6px 16px', fontSize: '13px', color: '#525f7f' }}>
                                {role.nome || role.name || role.role?.name || role.role?.nome || role.slug}
                              </div>
                            ))}
                            <hr style={{ margin: '4px 0' }} />
                            <Link
                              to="/admin/me/edit"
                              onClick={this.closeGearPanel}
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 16px', color: '#525f7f', textDecoration: 'none', fontSize: '13px' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f6f9fc' }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                            >
                              <i className="ni ni-single-02" />
                              <span>Minha conta</span>
                            </Link>
                            <hr style={{ margin: '4px 0' }} />
                            <div style={{ padding: '4px 16px 2px', fontSize: '11px', fontWeight: 600, color: '#8898aa', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                              Suporte
                            </div>
                            <a
                              href="https://ajuda.playnee.com"
                              target="_blank"
                              rel="noreferrer"
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 16px', color: '#525f7f', textDecoration: 'none', fontSize: '13px' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f6f9fc' }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                            >
                              <i className="fas fa-question-circle" />
                              <span>Central de Ajuda</span>
                            </a>
                            <a
                              href="https://api.whatsapp.com/send?phone=5579998782516"
                              target="_blank"
                              rel="noreferrer"
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 16px', color: '#525f7f', textDecoration: 'none', fontSize: '13px' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f6f9fc' }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                            >
                              <i className="fab fa-whatsapp" />
                              <span>Whatsapp</span>
                            </a>
                            <hr style={{ margin: '4px 0' }} />
                            <div
                              onClick={() => { this.closeGearPanel(); signout(); }}
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 16px', color: '#f5365c', cursor: 'pointer', fontSize: '13px' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#fff5f5' }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                            >
                              <i className="ni ni-user-run" />
                              <span>Logout</span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="d-flex align-items-center">
                        <NotificacoesLista direction="right" iconColor="#525f7f" />
                      </div>
                    </div>
                </div>
              )}
            </AuthContext.Consumer>
          </div>
        </Navbar>
      </>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => { },
  sidenavOpen: false,
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

export default Sidebar;
